import React, { useState, useEffect } from 'react';
import { Row, Col, Modal, ModalBody, Label } from 'reactstrap';
import Select from 'react-select';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Translate, { t } from '../common/Translate';
import useValue from '../../services/Form/useValue';

const ModalMultipleAnomaly = (props) => {
  const { isOpen } = props;

  return (
    <>
      <Modal isOpen={isOpen} centered>
        <ModalBody className="modal-body">
          <ListSelect {...props} />
        </ModalBody>
      </Modal>
    </>
  );
};

ModalMultipleAnomaly.propTypes = {
  isOpen: PropTypes.bool.isRequired,
};

export default ModalMultipleAnomaly;

const ListSelect = (props) => {
  const { questionId, listsOption: children, selectedElement, closeModal, sectionId, formId, questionType } = props;
  const [elementSelected, setElementSelected] = useState(selectedElement);
  const [options, setOptions] = useState([]);
  const [errorAnomaly, setErrorAnomaly] = useState(false);
  const [showSelectItem, setShowSelectItem] = useState(true);
  const [modalButtonDisable, setModalButtonDisable] = useState(true);
  const questionChild = _.get(children, `${elementSelected}.id`, '');
  const questionChildType = _.get(children, `${elementSelected}.type`, '');
  const [anomalyValue, setAnomalyValue] = useValue(
    formId,
    sectionId,
    questionId,
    questionType,
    `children.${elementSelected}.value`,
    '',
    questionChild,
    questionChildType,
  );

  const [anomalyValueInput, setAnomalyValueInput] = useState(anomalyValue);

  const handleChangeElement = (e) => {
    const element = e.value;
    if (showSelectItem) setShowSelectItem(false);
    if (element === '') setElementSelected('');
    else setElementSelected(e.value);
  };

  const validateValue = async () => {
    await setAnomalyValue(parseInt(anomalyValueInput, 10));
    closeModal();
  };

  const handleChange = (e) => {
    setModalButtonDisable(true);
    const { value } = e.target;
    if (value) {
      setModalButtonDisable(false);
    }

    if (parseInt(value, 10) === 0 || parseInt(value, 10) > 999) {
      setErrorAnomaly(true);
    } else {
      setErrorAnomaly(false);
    }
    setAnomalyValueInput(value);
  };

  if (children && options.length === 0) {
    const d = [];
    Object.keys(children).forEach((i) => {
      d.push({ label: t(i), value: i });
    });
    setOptions(d);
  }

  useEffect(() => {
    if (anomalyValue && modalButtonDisable === true) {
      setAnomalyValueInput(anomalyValue);
      setModalButtonDisable(false);
    }
  }, [anomalyValue]);

  return (
    <div data-cy={questionId}>
      <Label className="pl-2 text-left">
        <Translate code="anomaly" />
      </Label>
      <Select
        id="element"
        className="rounded"
        options={options}
        placeholder={t('select_element')}
        onChange={(e) => handleChangeElement(e)}
        value={elementSelected && { label: t(elementSelected), value: elementSelected }}
        isSearchable={false}
      />

      {elementSelected && (
        <div className="mt-4">
          <div className="form-group mt-4">
            <div className="pseudo-input-currency">
              <input
                id="anomalyValue"
                inputMode="tel"
                name="cost"
                type="number"
                className={`text-left form-control ${errorAnomaly ? 'is-invalid' : ''} `}
                value={anomalyValueInput}
                onChange={(e) => handleChange(e)}
              />
              <div className={`currency-wrapper mr-4 ${errorAnomaly ? 'text-danger' : ''}`}>{t('μm')}</div>
            </div>
          </div>
        </div>
      )}
      <Row className="mt-4 mb-2">
        <Col xs="5" className="text-center">
          <button type="button" className="btn btn-link px-2" onClick={closeModal}>
            <Translate code="cancel" />
          </button>
        </Col>
        <Col xs="7" className="text-center">
          <button
            type="submit"
            className={`btn ${modalButtonDisable || errorAnomaly ? 'btn-4' : 'btn-1'}`}
            disabled={modalButtonDisable || errorAnomaly}
            onClick={validateValue}
          >
            <Translate code="validate" />
          </button>
        </Col>
      </Row>
    </div>
  );
};

ListSelect.propTypes = {
  formId: PropTypes.string.isRequired,
  sectionId: PropTypes.string.isRequired,
  questionId: PropTypes.string.isRequired,
  selectedElement: PropTypes.string.isRequired,
  listsOption: PropTypes.shape(),
  closeModal: PropTypes.func.isRequired,
  questionType: PropTypes.string.isRequired,
};

ListSelect.defaultProps = {
  listsOption: null,
};
